<template>
  <v-sheet :color="left ? 'white' : 'primary'">
    <v-row
      class="item"
      :class="{ right: !left }"
      align="center"
      justify="center"
      no-gutters
    >
      <v-col v-if="mdAndUp" class="position-relative item-content-img" cols="6">
        <img
          class="d-block item-img"
          :src="files + img + '?resize=1&w=960'"
          :alt="title"
        />
      </v-col>

      <v-col cols="12" md="6">
        <v-row
          class="ma-0"
          justify="center"
          :justify-md="left ? 'start' : 'end'"
        >
          <v-col
            class="px-3 px-md-0 my-6 my-md-0 mx-md-10"
            :class="{ 'pl-md-16': left, 'pr-md-16': !left }"
            cols="12"
            sm="10"
            lg="7"
          >
            <div
              class="
                text-h5 text-lg-h3 text-center text-md-left text-uppercase
                font-weight-medium font-italic
              "
              :class="{
                'primary--text': left,
                'white--text': !left,
              }"
            >
              <span class="font-secondary">
                {{ title }}
              </span>
            </div>

            <img
              v-if="!mdAndUp"
              class="d-block mt-4 item-img"
              :src="files + img + '?resize=1&w=960'"
              :alt="title"
              width="100%"
            />

            <div
              class="
                text-body-1 text-center text-md-left
                grey--text
                mt-4
                item-text
              "
              :class="{
                'text--darken-1': left,
                'text--lighten-2': !left,
              }"
              v-html="introduction"
            ></div>

            <div class="text-center text-md-left">
              <v-btn
                class="font-weight-medium px-10 px-md-1 mx-n1 mt-4 mt-md-2"
                :class="{
                  'primary--text text--lighten-3': left,
                  'white--text': !left,
                }"
                color="transparent"
                :to="to"
                depressed
                tile
              >
                SAIBA MAIS
                <v-icon class="ml-3" size="14"> fa-arrow-right </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    introduction: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      required: true,
    },
    left: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    mdAndUp() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },
};
</script>

<style lang="scss" scoped>
.item::v-deep {
  .col {
    &:first-child {
      order: 0;

      &:before {
        background-image: url(../../assets/img/bg-product-left.png);
        background-size: cover;
        background-position: left center;
        content: "";
        height: 100%;
        position: absolute;
        right: -64px;
        top: 0;
        width: 64px;
      }
    }

    &:last-child {
      order: 12;
    }
  }

  &.right {
    .col {
      &:first-child {
        order: 12;

        &:before {
          background-image: url(../../assets/img/bg-product-right.png);
          background-position: right center;
          left: -64px;
          right: initial;
        }

        .item-img {
          margin-left: -32px;
        }
      }

      &:last-child {
        order: 0;
      }
    }
  }

  .item-img {
    aspect-ratio: 1000 / 530;
    object-fit: cover;
    -o-object-fit: cover;
    object-position: center;
    -o-object-position: center;

    @media screen and (min-width: 960.001px) {
      width: calc(100% + 32px);
    }
  }
}

.item-text::v-deep {
  -webkit-box-orient: vertical;
  box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  line-clamp: 6;
  line-height: 2em !important;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (max-width: 1264px) {
    -webkit-line-clamp: 4;
    line-clamp: 4;
  }

  @media screen and (max-width: 960px) {
    -webkit-line-clamp: 36;
    line-clamp: 36;
  }

  p:last-child {
    margin-bottom: 0;
  }
}
</style>
